import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  rootFlightsSummary: {
    '& .MuiPaper-elevation3': {
      marginBottom: '10px',
    },
    '& .phoneNumber': {
      textWrap: 'nowrap',
    },
  },
}));

export default useStyles;
